import {AttestationBatchStatus, BaseAttestation, Exercise, Range} from "@core/services/attestations";
import {Product} from "@core/services/settings/product/product.interface";
import {Company} from "@core/services/administration/company/company.interface";

export enum AttestationBatchType {
  ORIENTE_COMPAGNIE = "ORIENTE_COMPAGNIE",
  NON_ORIENTE_COMPAGNIE = "NON_ORIENTE_COMPAGNIE"
}

export class AttestationBatch extends BaseAttestation {
  batchNumber?: bigint;
  range?: Range;
  quantity?: number;
  receptionDate?: Date; // LocalDate → ISO string
  status?: AttestationBatchStatus;
  exercise?: Exercise;
  batchType?: AttestationBatchType;
  currentQuantity?: number;

  company?: string // UUID
  companyLabel?: string

  product?: string;        // UUID
  productsLabel?: string;

  referenceUuid?: string;
  referenceLabel?: string;
  referenceCompanyOriented?: boolean;

  cancelReason?: string;
  cancelInstant?: string;


  constructor(entity: Partial<AttestationBatch> = {}) {
    super(entity);
    Object.assign(this, entity);
  }

  public static labelOf(batch: AttestationBatch): string {
    if (batch.company && batch.companyLabel)
      return `${batch?.referenceLabel} - ${batch?.companyLabel} - ${batch?.batchNumber}`
    return `${batch?.referenceLabel} - ${batch?.batchNumber}`
  }

  public static hydrate(batchList: AttestationBatch[], productList: Product[], companyList: Company[]) {
    return batchList.map(batch => {
      const product = productList.find(p => p.id === batch.product);
      const company = companyList.find(p => p.id === batch.company);
      return new AttestationBatch({
          ...batch,
          companyLabel: company?.name,
          productsLabel: product?.name,
        })
      }
    )
  }
}
